import { jsx as _jsx } from "react/jsx-runtime";
import { useWidgetConfig } from '../../providers';
import { Card } from '../Card';
export const ContractComponent = (props) => {
    const { contractComponent } = useWidgetConfig();
    if (!contractComponent) {
        return null;
    }
    return (_jsx(Card, { flex: 1, ...props, children: contractComponent }));
};
